<template>
  <div class="d-flex justify-content-center">
    <div class="d-flex align-items-center">
      <b-spinner
        variant="primary"
        label="Loading"
        class="mr-4"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
      <div>
        <h2 class="mb-1">{{ $t(title) }}</h2>
        <p class="text-second m-0">
          {{ $t(message) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InitializationProgress",
  props: {
    title: {
      type: String,
      default: "data.wait",
    },
    message: {
      type: String,
      default: "verification.token.p",
    },
  },
};
</script>

<style scoped>
</style>